import React, { useState } from "react"
import { makeStyles, TextField, Hidden, withStyles } from "@material-ui/core"
import Cookies from "universal-cookie"


// Assets
import { Button, GridDialog } from ".."

import { Typography } from "@material-ui/core"
import { FormattedMessage, injectIntl } from "react-intl"
import "./popup.css"
import warning from "./warning.png"
import LeafLeft from "../../puraearth/src/images/leaf left.png"
import LeafRight from "../../puraearth/src/images/leaf right.png"
import { Moltin } from "avicanna-puraearth/src/services/Moltin"

const styles = makeStyles(theme => {
  return {
    body: {
      alignItems: "center",
      display: "flex",
      flexDirection: "column",
      padding: theme.spacing(8, 0),
    },
    content: {
      width: "100%",
      maxWidth: theme.spacing(50),
    },
    closebutton: {
      width: "100%",
      height: "20px",
      textAlign: "right",
      paddingRight: "20px",
    },
    close: {
      width: "10px",
      height: "10px",
      border: "none",
      fontSize: "20px",
      color: "#808080",
      outline: "none",
      cursor: "pointer",
      backgroundColor: "white",
    },
    title: {
      color: theme.palette.green.main,
      textAlign: "center",
    },
    failureTitle: {
      color: theme.palette.red.main,
      textAlign: "center",
    },
    failureCheck: {
      color: theme.palette.red.main,
      textAlign: "center",
      height: "100px",
    },
    bodyText: {
      marginBottom: theme.spacing(4),
    },
    successText: {
      textAlign: "center",
      marginBottom: theme.spacing(4),
    },
    popupContainer: {
      width: "100%",
      paddingTop: "5px",
      marginBottom: "32px",
      marginRight: "0",
      marginLeft: "0",
    },

    bottomContainer: {
      display: "flex",
      alignItems: "center",
      [theme.breakpoints.down("md")]: {
        flexDirection: "column",
        justifyContent: "center",
        textAlign: "center",
      },
    },
    socialContainer: {
      maxWidth: "1296px",
      textAlign: "center",
    },
    header: {
      textAlign: "center",
    },
    headerText: {
      fontFamily: theme.typography.fontFamily,
      marginBottom: "0",
      color: "#9abaae",
      marginTop: "5px",
      fontSize: "56px",
      fontWeight: "bold",
      textTransform: "upperCase",
      [theme.breakpoints.down("sm")]: {
        fontSize: "44px",
      },
    },
    discountText: {
      fontFamily: theme.typography.fontFamily,
      marginBottom: "30px",
      color: "#000",
      textTransform: "upperCase",
      fontSize: "23px",
      marginTop: "0",
      [theme.breakpoints.down("sm")]: {
        fontSize: "17px",
      },
    },
    subscribe: {
      margin: theme.spacing(3, 0, 2, 0),
      display: "flex",
      [theme.breakpoints.down("sm")]: {
        flexDirection: "column",
      },

      justifyContent: "center",
      alignItems: "center",
    },
    subscribeText: {
      marginRight: 20,
      fontFamily: theme.typography.fontFamily,
      fontSize: "20px",
      fontWeight: "normal",
    },
    socialIcon: {
      marginLeft: "40px",
    },
    socialIcon_1: {
      paddingLeft: "0px",
    },
    formContainer: {
      borderColor: theme.palette.black.support,
      [theme.breakpoints.down("sm")]: {
        width: "100%",
        paddingLeft: "10px",
        paddingRight: "10px",
      },
      [theme.breakpoints.up("md")]: {
        width: "380px",
      },
      height: "36px",
      justifyContent: "space-between",
      paddingTop: "0px",
      paddingBottom: "0px",
      display: "flex",
      alignItems: "center",
      width: "100%",
    },

    button: {
      height: "36px",
      fontFamily: theme.typography.fontFamily,
      fontSize: "13px",
    },
    textField: {
      position: "relative",
      borderColor: theme.palette.black.support,
      borderStyle: "solid",
      borderWidth: 1,
      width: "100%",
      height: "100%",
      padding: theme.spacing(0.3, 0, 0, 2),
      textTransform: "uppercase",
      fontSize: "18px",
    },
    checkContainer: {
      height: "auto",
      justifyContent: "space-between",
      paddingTop: "0px",
      paddingBottom: "0px",
      paddingLeft: "20px",
      paddingRight: "20px",
      display: "flex",
      alignItems: "center",
      width: "100%",
      position: "relative",
      [theme.breakpoints.down("sm")]: {
        paddingLeft: "0px",
        paddingRight: "0px",
      },
    },
    checktxt: {
      width: "90%",
      paddingLeft: "45px",
      textAlign: "left",
      [theme.breakpoints.down("sm")]: {
        paddingLeft: "31px",
        textAlign: "justify",
        fontSize: "11px",
      },
    },
    checkinput: {
      position: "absolute",
      top: "0",
      width: "10%",
    },
    hidden: {
      display: "none",
    },
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.58)",
      zIndex: "1000",
      position: "fixed",
      top: "0",
      left: "0",
      width: "100%",
      height: "100%",
    },
    content2: {
      position: "relative",
      height: "400px",
      top: "50px",
      left: "auto",
      right: "auto",
      bottom: "auto",
      maxWidth: "600px",
      margin: "10% auto",
      padding: 0,
      border: "solid 10px #ece7e3",
      borderRadius: "0",
      zIndex: "1001",
      backgroundColor: "#fff",
    },
    popover: {
      position: "relative",
      marginTop: "1.5rem",
      display: "inline-block",
    },
    warningImg: {
      position: "relative",
      height: "20px",
      width: "20px",
      marginRight: "8px",
      marginLeft: "-13px",
      top: "3px",
    },
    leafLeft: {
      position: "absolute",
      left: 0,
      top: "10%",
      width: 80,
      height: 77,
      [theme.breakpoints.down("sm")]: {
        display: "none",
      },
    },
    leafRight: {
      position: "absolute",
      right: 0,
      bottom: "10%",
      width: 80,
      height: 77,
      [theme.breakpoints.down("sm")]: {
        display: "none",
      },
    },
    receiveText: {
      color: "#000",
      fontSize: "17px",
      paddingLeft: "10%",
      paddingRight: "10%",
      marginTop: "0",
      fontFamily: "Proxima Nova,Roboto,Helvetica,Arial,sans-serif",
      marginBottom: "15px",
      textTransform: "upperCase",
      [theme.breakpoints.down("sm")]: {
        fontSize: "15px",
      },
    },
  }
})

export default injectIntl(props => {
  const locale = props.intl.locale

  const classes = styles(props)
  const [open, setOpen] = useState(false)
  const [email, setEmail] = useState("")
  const [valid, setValid] = useState(false)
  const [invalid, setInvalid] = useState(false)
  const [confirmation, setConfirmation] = useState(false)
  const [checked, setChecked] = useState(false)
  const [popupclose, setpopupclose] = useState(false)
  const [emailUsed, setemailUsed] = useState(false)
  const [err, seterr] = useState(false)
  const cookies = new Cookies()

  const isDiscountPopup = cookies.get("discountPopup")

  let discountPopupExpireDate = new Date
  discountPopupExpireDate.setFullYear(discountPopupExpireDate.getFullYear() + 10)

  const emailValidation = value => {
    const regex = /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@(([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return !regex.test(value)
  }

  const handleClose = () => {
    setOpen(false)
    setpopupclose(true)
    cookies.set("discountPopup", true, { path: "/", expires: discountPopupExpireDate })
  }

  const handleChange = e => {
    setEmail(e.target.value)
  }

  const handleCheck = () => {
    setChecked(!checked)
  }

  const sendEmail = (email, customerId) => {
    const data = {
      language: (locale === "es" ? "es" : "en"),
      email: email,
      name: "",
      customerId: customerId,
    }
    fetch(
      "https://ickr3dus78.execute-api.us-east-2.amazonaws.com/prod/email/subscription",
      {
        method: "post",
        body: JSON.stringify(data),
      },
    ).then(entry => {
      console.log("email sent ")
    }).catch(error => {
      console.error(error)
    })
  }

  const handleSubmit = () => {
    if (!emailValidation(email)) {
      if (checked) {
        const data = {
          type: "customer",
          name: "New Customer",
          email: email,
          isSubscribed: true,
          isPromoEligible: true,
        }
        Moltin.Customers.Create(data).then(response => {
          sendEmail(email, response.data.id)
          if (err === false) {
            setConfirmation(true)
            setOpen(true)
            setpopupclose(true)
            cookies.set("discountPopup", true, { path: "/", expires: discountPopupExpireDate })
            setTimeout(() => {
              setEmail("")
              setOpen(false)
            }, 6000)
          }
        }, errorResponse => {
          if (errorResponse.errors) {
            errorResponse.errors.forEach(error => {
                console.log(error)
                if (error.status === 409) {
                  seterr(true)
                  setConfirmation(false)
                  setemailUsed(true)
                  setOpen(true)
                  setTimeout(() => {
                    setEmail("")
                    setOpen(false)
                    setemailUsed(false)
                    seterr(false)
                  }, 6000)
                }
              },
            )
          }
        })
      } else {
        setChecked(false)
        setValid(true)
      }
    } else {
      setConfirmation(false)
      setInvalid(true)
      setOpen(true)
      setTimeout(() => {
        setEmail("")
        setOpen(false)
        setInvalid(false)
      }, 6000)
    }
  }


  return (
    <div className={isDiscountPopup === "true" || popupclose === true ? classes.hidden : classes.overlay}>
      <div className={classes.content2}>
        <div className={classes.popupContainer}>
          <div className={classes.socialContainer}>
            <div className={classes.closebutton}>
              <button className={classes.close} onClick={handleClose}>X</button>
            </div>
            <div className={classes.header}>
              <h3 className={classes.headerText}>
                <FormattedMessage id="popupHeader"/>
              </h3>
              <h3 className={classes.discountText}>
                <FormattedMessage id="discountHeader"/>
              </h3>
            </div>
            <div className={classes.subscribe}>
              <GridDialog
                fullScreen={"sm"}
                xs={8}
                onClose={handleClose}
                open={open}
              >
                <div className={classes.body}>
                  <img
                    src={LeafLeft}
                    className={classes.leafLeft}
                    alt={""}
                  />
                  <img
                    src={LeafRight}
                    className={classes.leafRight}
                    alt={""}
                  />
                  <div className={classes.content}>
                    {confirmation && (
                      <Typography
                        variant={"h4"}
                        classes={{ root: classes.title }}
                      >
                        <FormattedMessage id="thanksForSubscribing"/>
                      </Typography>
                    )}{" "}
                    {invalid && (
                      <Typography
                        variant={"h4"}
                        classes={{ root: classes.failureTitle }}
                      >
                        <FormattedMessage id="invalidEmail"/>
                      </Typography>
                    )}
                    {invalid && (
                      <Typography
                        classes={{ root: classes.successText }}
                        variant={"body1"}
                      >
                        <FormattedMessage id="pleaseEntervalidEmail"/>
                      </Typography>
                    )}
                    {emailUsed && (
                      <Typography
                        classes={{ root: classes.failureTitle }}
                        variant={"h4"}
                      >
                        <FormattedMessage id="duplicated"/>
                      </Typography>
                    )}
                    {emailUsed && (
                      <Typography
                        classes={{ root: classes.successText }}
                        variant={"body1"}
                      >
                        <FormattedMessage id="emailUsed"/>
                      </Typography>
                    )}
                  </div>
                </div>
              </GridDialog>
              <div className={classes.formContainer}>
                <FormattedMessage id="emailPlaceholder">
                  {msg => (
                    <TextField
                      value={email}
                      placeholder={msg}
                      fullWidth={true}
                      className={classes.textField}
                      type="email"
                      onChange={handleChange}
                    />
                  )
                  }
                </FormattedMessage>
                <Button
                  className={classes.button}
                  color={"green"}
                  onClick={handleSubmit}
                >
                  <FormattedMessage id="submit"/>
                </Button>
              </div>
            </div>
            <div>
              <h3 className={classes.receiveText}>
                <FormattedMessage id="receive"/>
              </h3>
            </div>
            <div className={classes.checkContainer}>
              <div className={classes.checkinput}>
                <input type="checkbox" id="check" checked={checked} onChange={handleCheck}/>
                <div className={valid && !checked ? classes.popover : classes.hidden}>
                  <div class="popover_content">
                    <img className={classes.warningImg} src={warning}/><FormattedMessage id="notChecked"/>
                  </div>
                </div>
              </div>
              <div className={classes.checktxt}>
                <label htmlFor="checkbox"><FormattedMessage id="checkbox"/></label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  )
})
